// Checks if we're in an iframe
export const isEmbedded = window !== window.top;
